import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PlanogramService } from 'src/app/services/planogram.service';
import { ProductReference } from "src/app/models/layout/product-reference";
import { LayoutService } from 'src/app/services/layout.service';
import { NgClass, DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-brand-report-modal',
    templateUrl: './brand-report-modal.component.html',
    styleUrls: ['./brand-report-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, DecimalPipe]
})
export class BrandReportModalComponent implements OnInit {
  reportData: any[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private layoutService: LayoutService
  ) { }

  ngOnInit() {
    this.generateReport();
  }

  generateReport() {
    const products = this.layoutService.planogramItems;
    const actualFacingCounts = this.layoutService.getActualFacingCounts();
    
    const totalProducts = products.size;
    const totalSales = Array.from(products.values()).reduce((sum, p) => sum + p.salesData.sales, 0);
    const totalSalesQty = Array.from(products.values()).reduce((sum, p) => sum + p.salesData.salesQty, 0);
    const totalFacings = Array.from(actualFacingCounts.values()).reduce((sum, count) => sum + count, 0);

    // Group products by brand
    const groupedByBrand = Array.from(products.values()).reduce((groups, product) => {
      const key = product.brand;
      (groups[key] = groups[key] || []).push(product);
      return groups;
    }, {} as Record<string, ProductReference[]>);

    this.reportData = Object.entries(groupedByBrand)
      .map(([brand, group]) => {
        const totalSkus = group.length;
        const brandSales = group.reduce((sum, p) => sum + p.salesData.sales, 0);
        const brandSalesQty = group.reduce((sum, p) => sum + p.salesData.salesQty, 0);
        const brandFacings = group.reduce((sum, p) => sum + (actualFacingCounts.get(p.productId) || 0), 0);
        const rangeContribution = (100 / totalProducts) * totalSkus;
        const salesContribution = (100 / totalSales) * brandSales;
        const volumeContribution = (100 / totalSalesQty) * brandSalesQty;
        const planoFacings = totalFacings > 0 ? (100 / totalFacings) * brandFacings : 0;
        const volumeVariance = Math.abs(planoFacings) - Math.abs(volumeContribution);
        let varianceColor = 0;

        if (Math.abs(volumeVariance) > 3 && Math.abs(volumeVariance) < 5) {
          varianceColor = 1;
        } else if (Math.abs(volumeVariance) >= 5) {
          varianceColor = 2;
        }

        return {
          brand,
          totalSkus,
          rangeContribution,
          salesContribution,
          volumeContribution,
          planoFacings,
          volumeVariance,
          varianceColor
        };
      })
      .sort((a, b) => b.volumeContribution - a.volumeContribution);
  }

  close() {
    this.activeModal.close();
  }
}
